
// Statging Environment
 export const environment = {
    production: false,
    appURL: "http://localhost:1337",
    graphURL: "http://localhost:1337/graphql?query=",
    token: "",
    ticketingURL: "https://testmms.versystec.com/ticketing/",
    releaseVersion: "STR.3.3.3 FE.25.03.12 - DEV"
  };
  

 // Production Environment 
  export const environment_prod = {
    production: true,
    appURL: "https://posbackend.versystec.com",
    graphURL: "https://posbackend.versystec.com/graphql?query=",
    token: "",
    ticketingURL: "https://pos.versystec.com/ticketing/",
    releaseVersion: "STR.3.3.3 FE.25.02.04/B"
  };
  
  

// LOCAL ENVIRONMENT
  export const environment_local = {
    production: true,
    appURL: "http://127.0.0.1:1337/api",
    graphURL: "http://127.0.0.1:1337/graphql?query=",
    token: "",
    ticketingURL: "https://pos.versystec.com/ticketing/",
    releaseVersion: "STR.3.3.3 FE.25.02.04/B"
  };
  
  

// Qtec ENVIRONMENT
  export const environment_qtec = {
    production: false,
    appURL: "http://46.226.110.157:1338",
    graphURL: "http://46.226.110.157:1338/graphql?query=",
    token: "",
    ticketingURL: "https://46.226.110.157/ticketing/",
    releaseVersion: "STR.3.3.3 FE.25.02.04/B"
  };
  
  

